(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() { super(); }

    connectedCallback() {
      /* Prefer the GROUP wrapper, else the SECTION, else this element */
      this.group = this.closest('.shopify-section-group-header');
      this.section = this.closest('.shopify-section') || document.querySelector('.section-header');
      this.headerNode = this.group || this.section || this; // node that receives sticky classes

      if (!this.headerNode) return;

      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';

      this.headerBounds = {};
      this.setHeaderHeight();

      const mq = window.matchMedia('(max-width: 990px)');
      if (mq && mq.addEventListener) mq.addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.headerNode.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.createObserver();
    }

    setHeaderHeight() {
      const ref = this.querySelector('.header') || this;
      document.documentElement.style.setProperty('--header-height', `${ref.offsetHeight || 0}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      const target = this.headerNode;
      if (!target) return;
      const observer = new IntersectionObserver((entries, obs) => {
        this.headerBounds = entries[0]?.intersectionRect || { top: 0, bottom: 0 };
        obs.disconnect();
      });
      observer.observe(target);
    }

    onScroll() {
      const el = this.headerNode;
      if (!el) return;

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        el.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        el.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        el.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide()   { if (!this.headerIsAlwaysSticky) this.headerNode.classList.add('shopify-section-header-hidden','shopify-section-header-sticky'); }
    reveal() { if (!this.headerIsAlwaysSticky) { this.headerNode.classList.add('shopify-section-header-sticky','animate'); this.headerNode.classList.remove('shopify-section-header-hidden'); } }
    reset()  { if (!this.headerIsAlwaysSticky) this.headerNode.classList.remove('shopify-section-header-hidden','shopify-section-header-sticky','animate'); }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
